import { IEvent } from '@interfaces/IEvent';

export interface IEventsState {
  events: IEvent[];
  selectedEvent: IEvent | null;
  success: boolean;
  selectedEventVisits: number[];
  periodEvents: {
    [key: number]: IEvent[];
  };
  loading?: {
    [key: string]: boolean;
  };
  errors: {
    addEvent?: { [key: string]: string[] };
    edit?: { [key: string]: string[] };
  };
}

export const initialEventsState: IEventsState = {
  events: [],
  periodEvents: {},
  errors: {},
  selectedEventVisits: [],
  success: false,
  selectedEvent: null,
};
